import type { ApiClient, IApiJsonRequest } from '../../ApiClient';
import type {
  IApiCreatePollRequestBody,
  IApiCreatePollResponseBody,
  IApiDeletePollResponseBody,
  IApiGetPollResponseBody,
  IApiGetPollResultsQueryBody,
  IApiGetPollResultsResponseBody,
  IApiGetPollsRequestBody,
  IApiGetPollsResponseBody,
  IApiUpdatePollRequestBody,
  IApiUpdatePollResponseBody,
} from './PollsApi.types';

export class PollsApi {
  public constructor(private client: ApiClient) {}

  public async getAll(
    appId: string,
    params?: IApiGetPollsRequestBody,
  ): Promise<IApiGetPollsResponseBody> {
    const request: IApiJsonRequest = {
      path: '/press/polls',
      method: 'get',
      params,
    };

    const response = await this.client.fetchJson<IApiGetPollsResponseBody>(
      request,
      { appId },
    );

    return response.body;
  }

  public async get(
    appId: string,
    pollId: string,
  ): Promise<IApiGetPollResponseBody> {
    const request: IApiJsonRequest = {
      path: `/press/polls/${pollId}`,
      method: 'get',
    };

    const response = await this.client.fetchJson<IApiGetPollResponseBody>(
      request,
      { appId },
    );

    return response.body;
  }

  public async getResults(
    appId: string,
    pollId: string,
    body?: IApiGetPollResultsQueryBody,
  ): Promise<IApiGetPollResultsResponseBody> {
    const request: IApiJsonRequest = {
      path: `/admin/press/polls/${pollId}/results`,
      method: 'get',
      params: body,
    };

    const response =
      await this.client.fetchJson<IApiGetPollResultsResponseBody>(request, {
        appId,
      });

    return response.body;
  }

  public async create(
    appId: string,
    body: IApiCreatePollRequestBody,
  ): Promise<IApiCreatePollResponseBody> {
    const request: IApiJsonRequest = {
      path: '/admin/press/polls',
      method: 'post',
      body,
    };

    const response = await this.client.fetchJson<IApiCreatePollResponseBody>(
      request,
      { appId },
    );

    return response.body;
  }

  public async update(
    appId: string,
    pollId: string,
    body: IApiUpdatePollRequestBody,
  ): Promise<IApiUpdatePollResponseBody> {
    const request: IApiJsonRequest = {
      path: `/admin/press/polls/${pollId}`,
      method: 'patch',
      body,
    };

    const response = await this.client.fetchJson<IApiUpdatePollResponseBody>(
      request,
      { appId },
    );

    return response.body;
  }

  public async delete(
    appId: string,
    pollId: string,
  ): Promise<IApiDeletePollResponseBody> {
    const request: IApiJsonRequest = {
      path: `/admin/press/polls/${pollId}`,
      method: 'delete',
    };

    const response = await this.client.fetchJson<IApiDeletePollResponseBody>(
      request,
      {
        appId,
      },
    );

    return response.body;
  }
}
